import IndexedDBHandler from "./IndexedDBHandler";
import TelemetryClientConfig from "./models/TelemetryClientConfig";
import TokenAuthenticator from "./models/TokenAuthenticator";

const DB_NAME = "console_feature_test";
const DB_VERSION = 2;
const TEST_STORE_NAME = "test";

class TelemetryClient {
  private static realmToTelemetryURLs: Record<string, string[]> = {
    r1: ["https://console-telemetry.r1.oci.oracleiaas.com"],
    oc1: [
      "https://console-telemetry.us-phoenix-1.oci.oraclecloud.com",
      "https://console-telemetry.us-ashburn-1.oci.oraclecloud.com",
    ],
    oc2: [
      "https://console-telemetry.us-langley-1.oci.oraclegovcloud.com",
      "https://console-telemetry.us-luke-1.oci.oraclegovcloud.com",
    ],
    oc3: [
      "https://console-telemetry.us-gov-phoenix-1.oci.oraclegovcloud.com",
      "https://console-telemetry.us-gov-ashburn-1.oci.oraclecloud.com",
      "https://console-telemetry.us-gov-chicago-1.oci.oraclegovcloud.com",
    ],
    oc4: ["https://console-telemetry.uk-gov-london-1.oci.oraclegovcloud.uk"],
    oc5: ["https://console-telemetry.us-tacoma-1.oci.oraclecloud5.com"],
    oc6: ["https://console-telemetry.us-gov-fortworth-1.oci.oraclecloud.ic.gov"],
    oc7: ["https://console-telemetry.us-gov-sterling-1.oci.oc.ic.gov"],
  };

  public static config: TelemetryClientConfig;
  public static isIndexedDBAvailable: boolean;

  /**
   * Function to check if the Telemetry Client is configured or not
   */
  public static get isInitialized() {
    return !!TelemetryClient.config;
  }

  /**
   * Function to configure the telemetry client
   * @param config: configurations
   */
  public static async initialize(config: TelemetryClientConfig) {
    TelemetryClient.config = { ...config };
    if (TelemetryClient.config.postToTelemetryService === undefined) {
      TelemetryClient.config.postToTelemetryService = true;
    }
    TelemetryClient.isIndexedDBAvailable = await IndexedDBHandler.testIndexedDB(TEST_STORE_NAME, DB_NAME, DB_VERSION);
  }

  public static setAuthInstance(authInstance: TokenAuthenticator) {
    TelemetryClient.config.authInstance = authInstance;
  }

  public static setTelemetryURLs(telemetryURLs: string[]) {
    TelemetryClient.config.telemetryURLs = telemetryURLs;
  }

  public static setRealm(realm: string) {
    TelemetryClient.config.realm = realm;
    const telemetryURLs = TelemetryClient.realmToTelemetryURLs[realm];
    if (telemetryURLs) {
      TelemetryClient.setTelemetryURLs(telemetryURLs);
    }
  }
}

export default TelemetryClient;
